import React, { useState } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Get_test } from "../../gql/queries";
import { useQuery } from "@apollo/client";

export default function TestTopicAnalysis() {
    let location = useLocation();
    const naviagte = useNavigate()
    let { id } = useParams()
    const [mydata, setMydata] = useState(JSON.parse(location.state));
    const [status, setStatus] = useState(0);
    const query1 = useQuery(Get_test, {
        variables: {
            "_id": id,
        },
    });

    let topicExist = false

    query1.data && query1.data.test.progress.subjectStats.map(on => {
        if ((on.topics?.some(item => item.topicId === null))) {
            topicExist = true
        }
    })
    // console.log(query1.data)
    return (
        <div className="main_wrapper">
            <div className="breadcrumbs">
                <ul className="breadcrumb">
                    {/* <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item"><a href="/">Test</a></li>
                    <li className="breadcrumb-item"><a href="/">Test Category</a></li>
                    <li className="breadcrumb-item"><a href="/">G Test-1 (Express RTS)</a></li>
                    <li className="breadcrumb-item active"><a href="/">Performance Summary</a></li> */}
                </ul>
            </div>
            <section className="videoLayer_wrapper testPerformance_wrapper testAnalysis_wrapper section_side_padding">
                <div className='row'>
                    <div className="col-lg-8 col-md-7 col-sm-12">
                        <div className="subjects_wrapper">
                            <div className="setting_ttl_wrapper d-flex align-items-baseline">
                                <figure className="sett_back_arrow" onClick={() => naviagte(-1)}>
                                    {/* <Link to={`/testlayer/testperformance/${id}`}> */}
                                        <img src={Icons.BackArrow} alt="" className="img-fluid" />
                                    {/* </Link> */}
                                </figure>
                                <figure className="subject_inner_img">
                                    <img src={mydata.subject.icon ? mydata.subject.icon : Images.defaultImg} alt="" className="img-fluid" />
                                </figure>
                                <div className="sett_ttl">
                                    <h5>{mydata.subject.subjectName}</h5>
                                    <p>
                                        <span>Subject Analysis</span>
                                        <span>Test</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="recommended_video_wrapper">
                            <div className="test_result_report subject_analysis_ttl">
                                <h6>All Topic<span>({mydata ? mydata.topics.length : 0})</span></h6>
                            </div>
                            <div className="subject_analysis_wrapper">
                                <div id="accordion">
                                    {
                                        mydata && mydata?.topics?.map((d, i) => (
                                            <div class="subject_analysis_card">
                                                <div class="subanaysis_header">
                                                    <a class="card-link" data-toggle="collapse" href={`#collapse${i}`}>
                                                        <div className="subject_analysis d-flex align-items-center">
                                                            <figure className="sanalysis_img">
                                                                <img src={Images.defaultImg} alt="" className="img-fluid" />
                                                            </figure>
                                                            <div className="sanalysis_text">
                                                                {
                                                                    mydata && mydata?.subject?.qbTopics?.map(obj => (
                                                                        (d.topicId) === (obj._id) &&
                                                                        <h6>{obj.title}<span>({d.attemptedQids + d.unattemptedQids} Questions)</span></h6>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div>
                                                        <span className="sub_arrow">
                                                            <img src={Icons.BookmarkArrow} alt="" className="img-fluid" />
                                                        </span>
                                                    </a>
                                                </div>
                                                <div id={`collapse${i}`} className={`${status == i ? 'collapse show' : 'collapse'}`} data-parent="#accordion">
                                                    <div className="subanalysis_performance">
                                                        <ul type="none" className="analysis_report d-flex align-items-center flex-wrap">
                                                            {
                                                                topicExist === false &&
                                                                <li>
                                                                    <Link to={`/testlayer/viewallsolution/${id}`} state={JSON.stringify({
                                                                        index: mydata?.subjectId,
                                                                        sub: i,
                                                                        text: "attempt"
                                                                    })}>
                                                                        <div className="result_percentage">
                                                                            <h6>{d.attemptedQids}</h6>
                                                                            <p>Attempted</p>
                                                                        </div>
                                                                    </Link>
                                                                </li>
                                                            }
                                                            {
                                                                topicExist !== false &&
                                                                <li>
                                                                    <div className="result_percentage">
                                                                        <h6>{d.attemptedQids}</h6>
                                                                        <p>Attempted</p>
                                                                    </div>
                                                                </li>
                                                            }
                                                            {
                                                                topicExist === false &&
                                                                <li className="">
                                                                    <Link to={`/testlayer/viewallsolution/${id}`} state={JSON.stringify({
                                                                        index: mydata?.subjectId,
                                                                        sub: i,
                                                                        text: "correct"
                                                                    })}>
                                                                        <div className="result_percentage correct">
                                                                            <h6>{d.correctQids}</h6>
                                                                            <p>Correct</p>
                                                                        </div>

                                                                    </Link>
                                                                </li>
                                                            }
                                                            {
                                                                topicExist !== false &&
                                                                <li className="">
                                                                    <div className="result_percentage correct">
                                                                        <h6>{d.correctQids}</h6>
                                                                        <p>Correct</p>
                                                                    </div>
                                                                </li>
                                                            }
                                                            {
                                                                topicExist === false &&
                                                                <li className="">
                                                                    <Link to={`/testlayer/viewallsolution/${id}`} state={JSON.stringify({
                                                                        index: mydata?.subjectId,
                                                                        sub: i,
                                                                        text: "incorrect"
                                                                    })}>
                                                                        <div className="result_percentage incorrect">
                                                                            <h6>{d.incorrectQids}</h6>
                                                                            <p>Incorrect</p>
                                                                        </div>

                                                                    </Link>
                                                                </li>
                                                            }
                                                            {
                                                                topicExist !== false &&
                                                                <li className="">
                                                                    <div className="result_percentage incorrect">
                                                                        <h6>{d.incorrectQids}</h6>
                                                                        <p>Incorrect</p>
                                                                    </div>
                                                                </li>

                                                            }
                                                            {
                                                                topicExist === false &&
                                                                <li className="">
                                                                    <Link to={`/testlayer/viewallsolution/${id}`} state={JSON.stringify({
                                                                        index: mydata?.subjectId,
                                                                        sub: i,
                                                                        text: "skip"
                                                                    })}>
                                                                        <div className="result_percentage unanswered">
                                                                            <h6>{d.unattemptedQids}</h6>
                                                                            <p>Unanswered</p>
                                                                        </div>
                                                                    </Link>
                                                                </li>
                                                            }
                                                            {
                                                                topicExist !== false &&
                                                                <li className="">
                                                                    <div className="result_percentage unanswered">
                                                                        <h6>{d.unattemptedQids}</h6>
                                                                        <p>Unanswered</p>
                                                                    </div>
                                                                </li>
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                    {/* <div class="subject_analysis_card">
                                        <div class="subanaysis_header">
                                            <a class="card-link" data-toggle="collapse" href="#collapseThree">
                                                <div className="subject_analysis d-flex align-items-center">
                                                    <figure className="sanalysis_img">
                                                        <img src={Icons.Anatomy} alt="" className="img-fluid"/>
                                                    </figure>
                                                    <div className="sanalysis_text">
                                                        <h6>Cranial Nerve- III, IV <span>(6 Questions)</span></h6>
                                                    </div>
                                                </div>
                                                <span className="sub_arrow">
                                                    <img src={Icons.BookmarkArrow} alt="" className="img-fluid"/>
                                                </span>
                                            </a>
                                        </div>
                                        <div id="collapseThree" class="collapse" data-parent="#accordion">
                                            <div className="subanalysis_performance">
                                                <ul type="none" className="analysis_report d-flex align-items-center flex-wrap">
                                                    <li>
                                                        <div className="result_percentage">
                                                            <h6>188</h6>
                                                            <p>Attempted</p>
                                                        </div>
                                                    </li>
                                                    <li className="">
                                                        <div className="result_percentage correct">
                                                            <h6>188</h6>
                                                            <p>Correct</p>
                                                        </div>
                                                    </li>
                                                    <li className="">
                                                        <div className="result_percentage incorrect">
                                                            <h6>188</h6>
                                                            <p>Incorrect</p>
                                                        </div>
                                                    </li>
                                                    <li className="">
                                                        <div className="result_percentage unanswered">
                                                            <h6>188</h6>
                                                            <p>Unanswered</p>
                                                        </div>
                                                    </li>
                                                </ul>
                                                <a href="javascript:;" className="topic_text">Check Topic Wise Analysis <img src={Icons.SubjectArrow} alt="" className="img-fluid"/></a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="subject_analysis_card">
                                        <div class="subanaysis_header">
                                            <a class="card-link" data-toggle="collapse" href="#collapseFour">
                                                <div className="subject_analysis d-flex align-items-center">
                                                    <figure className="sanalysis_img">
                                                        <img src={Icons.Anatomy} alt="" className="img-fluid"/>
                                                    </figure>
                                                    <div className="sanalysis_text">
                                                        <h6>Cranial Nerve- III, IV <span>(6 Questions)</span></h6>
                                                    </div>
                                                </div>
                                                <span className="sub_arrow">
                                                    <img src={Icons.BookmarkArrow} alt="" className="img-fluid"/>
                                                </span>
                                            </a>
                                        </div>
                                        <div id="collapseFour" class="collapse" data-parent="#accordion">
                                            <div className="subanalysis_performance">
                                                <ul type="none" className="analysis_report d-flex align-items-center flex-wrap">
                                                    <li>
                                                        <div className="result_percentage">
                                                            <h6>188</h6>
                                                            <p>Attempted</p>
                                                        </div>
                                                    </li>
                                                    <li className="">
                                                        <div className="result_percentage correct">
                                                            <h6>188</h6>
                                                            <p>Correct</p>
                                                        </div>
                                                    </li>
                                                    <li className="">
                                                        <div className="result_percentage incorrect">
                                                            <h6>188</h6>
                                                            <p>Incorrect</p>
                                                        </div>
                                                    </li>
                                                    <li className="">
                                                        <div className="result_percentage unanswered">
                                                            <h6>188</h6>
                                                            <p>Unanswered</p>
                                                        </div>
                                                    </li>
                                                </ul>
                                                <a href="javascript:;" className="topic_text">Check Topic Wise Analysis <img src={Icons.SubjectArrow} alt="" className="img-fluid"/></a>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}